module.exports = __webpack_public_path__ + "img/team.13eff9c8.png";